// extracted by mini-css-extract-plugin
export default {"root":"SectionBuyerProtection_root__eCiBt","sectionHeading":"SectionBuyerProtection_sectionHeading__t2z3w p","text":"SectionBuyerProtection_text__4pIN1 marketplaceSmallFontStyles"};